module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAM5JREFUOE/t1LEOwVAUBuD/J5o+BtdsYjYIRrPBaDOYJFqDu6hH8RBewGIw0+pgIhHGGhzBIARJqzH1PsCX8/859xAxP8bs4X+gOGqCDLvsudtrChnn2hB0gHSd9mr3KdnHCcVRArJEy53fQTWEQINYIDhVqDf7d2g4ECgDMCAwkUKVfe/4ioYFiwhSLRjnKSgzWuvuzyAtryE6awIwqf1DLOC3VQsd+TphAj41kHT4qEMctQTPNVq+f/vLo3wTRIG2O4i0NlHv5P/uYdQJL8yRkRWO83kVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/set_icon_litre_s.png
// module id = ++Bj
// module chunks = 0